export default __webpack_public_path__ + "static/media/Utsav Mukherjee.0d9fd472.jpg";